import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
// import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import seckillGoodsList from './components/seckillGoodsList/seckillGoodsList.vue'
import seckillSwiper from './components/seckillSwiper/seckillSwiper.vue'
import seckillCountDown from './components/seckillCountDown/seckillCountDown.vue'
import seckillTimeRangeSelect from './components/seckillTimeRangeSelect/seckillTimeRangeSelect.vue'
import seckillTop from './components/seckillTop/seckillTop.vue'
// import seckillNoFund from './components/seckillNoFund/seckillNoFund.vue'
import InfiniteLoading from 'vue-infinite-loading'
import _ from 'lodash'

import {
    wxShare
} from '@/utils/wxsdk'

import {
    getSeckillInfo,
    getSeckillGoodsList
} from '@/models/seckill'

export default {
    name: viewName.seckill,
    inject: ['hideLoading', 'showLoading'],
    components: {
        // infiniteLoadData,
        seckillTop,
        seckillTimeRangeSelect,
        seckillCountDown,
        seckillGoodsList,
        seckillSwiper,
        // seckillNoFund,
        InfiniteLoading
    },
    data () {
        return {
            t1: null, // 定时器(计算当前时间)
            nowTimeRange: {}, // 当前选中的时间段
            countDownTimes: 0, // 倒计时剩余秒数,默认为0
            // 1:活动中， 2：非活动中
            is_activity: '1',
            ppt: [],
            list: [],
            buy_time: [],
            now_time: 1585639715,
            topic_title: '',
            sstore_name: '',
            topic_img: 'https://image.carisok.com/images/seckill_banner_default.png',
            topic_explain: '',
            share: {
                title: '',
                desc: '',
                imgUrl: '',
            },
            page: 1,
            pageSize: 20,
            activityId: '', // 活动id
            sstore_id: '', // 门店id, phpID
            java_storeId: '', // 门店id, javaId
            ad_code: '', // 广告位置编码（运营后台添加广告位置）
            flag: true, // 用来判断是否请求主题数据
            // 定位坐标
            position: {
                longitude: '',
                latitude: ''
            }
        }
    },
    computed: {
        ...mapState({
            icarAppInfo: ({ appInfo }) => appInfo.icarAppInfo,
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        }),
    },
    watch: {
        '$route' (to, from) {
            // 当前页面跳当前页面就刷新当前页面
            if (to.path === '/seckill' && from.path === '/seckill') {
                const { activity_id, sstore_id } = to.query
                this.sstore_id = sstore_id || ''
                this.activityId = activity_id || ''
                this.flag = true
                this.page = 1
                this.list = []
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
                this.infinite = this.infiniteHandler()
            }
        }
    },
    created () {
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
        const { activity_id, sstore_id, ad_code } = this.$route.query
        this.activityId = activity_id || this.icarAppInfo.activity_id || ''
        this.sstore_id = sstore_id || this.icarAppInfo.sstore_id || ''
        this.java_storeId = this.icarAppInfo.java_storeId || ''
        this.ad_code = ad_code || '' // 后端接口有这个，目前说不用，后期不知道用不用，目前可为空可不传
    },
    activated () {

    },
    mounted () {
        // !this.sstore_id && this.getMyLocation()
        this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
        this.infinite()
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            const { activity_id, sstore_id } = to.query
            vm.sstore_id = sstore_id || ''
            vm.activityId = activity_id || ''
            vm.flag = true
            vm.page = 1
            vm.list = []
            vm.infinite = vm.infiniteHandler()
            vm.$refs.infiniteLoading && vm.$refs.infiniteLoading.stateChanger.reset()
        })
    },
    // beforeRouteLeave (to, from, next) {
    //     if (to.name === 'goodsDetail') {
    //         from.meta.keepAlive = false
    //     }
    //     next()
    // },
    /* 销毁定时器 */
    beforeDestroy () {
        clearInterval(this.t1)
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getLocation',
        ]),
        /**
         * 配置微信分享
         * @param {Object} detail
         */
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    title: detail.title,
                    desc: detail.desc,
                    imgUrl: detail.img,
                    flag: 1
                })
            }
        },
        /**
         * 倒计时回调
         * @param {object} timeInfo
         */
        onCountDownCallBack (timeInfo) {
            this.countDownTimes = timeInfo.remainTime
        },
        /**
         * 时间范围选择
         * @param {object} obj
         * @param {boolean} 一进入页面是否加载商品列表数据，默认不加载
         */
        onTimeRangeSelect (obj, status = true) {
            /* 选择当前时间段 */
            this.nowTimeRange = obj
            /* 调用倒计时 */
            this.$refs.seckillCountDown.startCountDown(this.now_time, this.nowTimeRange)
            /* 重新加载秒杀商品列表数据 */
            if (status)  {
                this.isload = true
                this.page = 1
                this.list = []
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
            }
        },
        /**
         * 每秒减一
         */
        calculateTime () {
            this.t1 = setInterval(() => {
                this.now_time++
            }, 1000)
        },
        infinite () {

        },
        infiniteHandler () {
            return _.debounce(() => {
                this.getGoodsListData()
            }, 200)
        },
        /**
         * 获取秒杀主题信息
         */
        async getMainData () {
            try {
                this.showLoading()
                const params = {
                    // 门店ID（不传就是多店）
                    sstore_id: this.sstore_id,
                    // 秒杀活动id
                    activity_id: this.activityId,
                    // 广告位置编码（运营后台添加广告位置）
                    ad_code: this.ad_code,
                    // page: '',
                    // pagesize 展示几个时间段
                    pagesize: '6'
                }
                const res = await getSeckillInfo(params)
                Object.assign(this, res)
                if (Number(this.is_activity) !== 1) {
                    this.$router.push({
                        path: '/pageNotFound',
                        query: {
                            sstore_id: this.sstore_id,
                        }
                    })
                }
                !this.sstore_id && this.getMyLocation()
                /* 配置微信分享 */
                this.configWxShare(res.share)
                /* 获取倒计时时间 */
                if (this.buy_time.length !== 0) {
                    /* 设置默认时间段 */
                    this.onTimeRangeSelect(this.buy_time[0], false)
                    /* 调用倒计时 */
                    this.$refs.seckillCountDown.startCountDown(this.now_time, this.nowTimeRange)
                }
                this.calculateTime()
                this.$emit('setHeader', {
                    title: this.topic_title || (Number(this.is_activity) === 0 ? '整点秒杀' : '整点大秒杀'),
                    showLeft: true,
                    hasSearch: false,
                    showRight: false,
                    showHeader: !this.$bridge.isStore()
                })
                this.sstore_id && this.hideLoading()
            } catch (_) {
                this.hideLoading()
            }
        },
        /**
         * 获取秒杀主题商品信息
         */
        async getGoodsListData () {
            try {
                // 之所以这种做事为了避免商品列表接口获取不了开始时间参数
                if (this.flag) {
                    await this.getMainData()
                    this.flag = false
                }
                const params = {
                    // 门店ID（不传就是多店）
                    sstore_id: this.sstore_id,
                    // 秒杀活动id
                    activity_id: this.activityId,
                    // 开始时间(秒杀时间段的起始时间)
                    begin_time: this.nowTimeRange.start,
                    // 页码，默认为1
                    page: this.page,
                    // 单页加载数，默认为10
                    pagesize: this.pageSize
                }
                const res = await getSeckillGoodsList(params)
                this.list.push(...res.data)
                if (res.data.length < this.pageSize) {
                    this.page = 1
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                } else {
                    this.page++
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                }
            } catch (err) {
                console.error(err)
            }
        },
        getMyLocation () {
            const options = { timeout: 3000, from: 'noTips' }
            // const geolocation = new qq.maps.Geolocation('3PDBZ-UERCW-ZBORT-OIRZ4-NKWD6-ZMBI6', 'fc')
            this.getLocation(options).then(this.showPosition).catch(this.showErr)
        },
        /* 获取位置信息成功 */
        showPosition ({lng, lat}) {
            this.position.longitude = lng
            this.position.latitude = lat
            // this.longitude = 113.326233
            // this.latitude = 23.197102
            this.hideLoading()
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            // 定位同和地铁站
            this.position.longitude = 113.326233
            this.position.latitude = 23.197102
            this.hideLoading()
        }
    },
    destroyed () {

    },
}
